import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

const HomeAbout = ({ className }) => {
  return (
    <section className={className}>
      <div className={"max-w-6xl mx-auto"}>
        <div className={"px-6 md:px-4"}>
          <div className={"w-full grid md:grid-cols-12 gap-8 md:gap-20"}>
            <div className={"md:col-span-6 lg:col-span-5"}>
              <h3 className={"text-3xl text-navy font-bold mb-4"}>
                About Norfolk Trailers
              </h3>

              <p>
                We are no strangers to the Ifor Williams brand as we have been
                working for many years within the trailer business. Our aim is
                to keep the full range of Ifor Williams trailers in stock with
                approximately 70-80 trailers on site at all times.
              </p>
              <p>
                We currently stock a full range of the following Ifor Williams
                Trailers:
                <Link to={"/trailers/horsebox"}>Horse Trailers</Link>,
                <Link to={"/trailers/car-transporter"}>
                  Car Transporter Trailers
                </Link>
                , General Duty Trailers, Livestock Trailers, Tipping Trailers,
                Commercial Trailers, Box Van Trailers, Flat Bed Trailers &
                Unbraked Trailers. Complementing the new Ifor Williams range are
                a number of Second Hand Trailers (various makes & models), to
                suit all budgets.
              </p>
              <p>
                Along with a fully set up Trailer Servicing area, we can also
                offer a full range of Hire Trailers, and an extensive range of
                Ifor Williams spares & accessories.
              </p>
            </div>

            <div className="md:col-span-6 lg:col-span-7 mb-8 md:mb-0 md:order-1 flex items-center">
              <StaticImage
                src={"../images/about.jpg"}
                alt={"Mike & Claire Berridge, Norfolk Trailers"}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeAbout
